module.exports = __webpack_public_path__ + "assets/img/tab_img_sh.89f0af47.png";